import React from "react";
import { DatePicker } from "@pd/pd-ui-kit";
import { endOfMonth } from "date-fns";
import type { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";

import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { IQExcludedDatesList } from "~/pages/Q";

import s from "./QFilter.module.less";

interface QFilterProps {
  currentDate?: Date;
  allowDates: IQExcludedDatesList;
}

export const QFilter = ({ currentDate, allowDates }: QFilterProps) => {
  const { t } = useTranslation();
  const setData = useSetLocationData();
  const { selectedDate } = useGetLocationData();

  // Как в старом DealerInfoPanel: доступны для выбора только месяцы из allowDates
  const disabledDate = (current: Dayjs) => {
    const allowedMonths = allowDates[current.year()] || [];
    return !allowedMonths.includes(current.month() + 1);
  };

  const handleChange = (date: Dayjs | null) => {
    date && setData("selectedDate", endOfMonth(date.toDate()));
  };

  return (
    <div className={s.field}>
      <span className={s.label}>{t("q.show_for")}</span>
      <DatePicker
        picker="month"
        format="MM.YYYY"
        size="small"
        allowClear={false}
        className={s.datePicker}
        value={selectedDate ? new Date(selectedDate) : currentDate || null}
        disabledDate={disabledDate}
        onChange={handleChange}
      />
    </div>
  );
};
